<template>
    <div class="mt-2">
        <Select2 class="form-control" v-model="myValue" :options="myOptions"
        :settings="{ placeholder:'Write/select members',width:'100%', }"
        @select="mySelectEvent($event)"/>
        <div  class="row mt-3">
            <div class="col-md-12 col-12 ">
                <ul class="flex-container list-unstyled">
                    <li class="p-2 m-1 container-bg" v-for="value in selectedMembers" v-bind:key="'member'+value.id">
                        {{ value.text }}
                        <i class="fas fa-times ml-2 text-danger" style="cursor: pointer" v-on:click="deleteSelection(value.id)"></i></li>
                </ul>
            </div>
        </div> 

    </div>


</template>

<script>
import { mapState } from 'vuex'
    export default {
        name: "members", 
        data() {
            return {
                myValue: '',
                myOptions: []
            }
        },
        computed:{
            ...mapState({
                selectedMembers :(state)=> state.selectedMembers,
                members :(state)=> state.members,
            })
        },
        methods: {
            mySelectEvent() {
                var newOptions = [];
                this.myOptions.forEach((item) => {
                    var disabled = item.disabled;
                    var id = item.id;
                    var text = item.text;
                    if (item.id == this.myValue) {
                        disabled = true;
                    }
                    var obj = {
                        id,
                        text,
                        disabled
                    }
                    //selectedValue
                    if (item.id == this.myValue) { 
                        this.$store.state.selectedMembers.push(obj);
                    }
                    newOptions.push(obj)
                    
                });
                this.myOptions = newOptions;
                this.myValue = '';
            },
            deleteSelection(value){
                var newOptions = [];
                this.myOptions.forEach((item) => {
                    var disabled = item.disabled;
                    var id = item.id;
                    var text = item.text;
                    if (item.id == value) {
                        disabled = false;
                    }
                    var obj = {
                        id,
                        text,
                        disabled
                    }

                    newOptions.push(obj)
                    //selectedValue
                    this.$store.state.selectedMembers.forEach((item,index)=>{
                        if (item.id == value) {
                            this.$store.state.selectedMembers.splice(index,1);

                        }
                    });
                });
                this.myOptions = newOptions;
            },
            deleteEditCommitteemembers(id){
                this.$parent.committee.users = this.$parent.committee.users.filter((d)=> d.id != id);

            }
        },
       created(){
            this.$store.dispatch('get','api/v1/users').then((data)=>{ 
                var newOptions = [];
                data.data.data.forEach((item)=>{
                    var disabled = item.disabled;
                    var id = item.id;
                    var text = item.display_name;
                    var obj = {
                        id,
                        text,
                        disabled
                    }
                    newOptions.push(obj)
                });
                this.$store.state.members = [...data.data.data]
                this.myOptions=newOptions; 
            }) 
        }, 
    }
</script>

<style scoped>
    .form-control, .input-group-text {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 1px 5px 10px #00000029;
        border-radius: 4px;
        opacity: 1;
        border: 1px #ced4da;;
    }
    .flex-container {
        display: flex;
        flex-flow: row wrap;
        position: relative;
        width: auto;
        align-items: center;

        opacity: 1;
    }

</style>
